import { render, staticRenderFns } from "./TemplateViewEmail.vue?vue&type=template&id=b23061c6&"
import script from "./TemplateViewEmail.vue?vue&type=script&lang=ts&"
export * from "./TemplateViewEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports